import { KeyValuePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'c-validation-error',
    templateUrl: './validation-error.component.html',
    styleUrls: ['./validation-error.component.scss'],
    imports: [KeyValuePipe, TranslocoPipe],
})
export class ValidationErrorComponent {
  @Input() validationMessages: ValidationErrors | undefined;
  @Input() controlValue: string | undefined;
}
